import { c as _c } from "react/compiler-runtime";
import { AnalyticsFeatureViewed as FeatureViewed } from '@cc-shopping/platform-analytics/AnalyticsFeatureViewed';
import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { CardsApprovalLine } from './CardsApprovalLine';
import { type ApprovalOddsValues, Likelihood } from './constants';
export type CardsApprovalOddsProps = {
  approvalLikelihood: ApprovalOddsValues | null;
  isLoading?: boolean;
  desktopStyle?: boolean;
};
const CardsApprovalOdds = t0 => {
  const $ = _c(17);
  const {
    approvalLikelihood,
    isLoading,
    desktopStyle
  } = t0;
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton height={124} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== approvalLikelihood?.label) {
    t1 = approvalLikelihood?.label?.toLowerCase();
    $[1] = approvalLikelihood?.label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== skuImpressionId || $[4] !== t1) {
    t2 = {
      approval_odds: t1,
      parent_activity_id: skuImpressionId
    };
    $[3] = skuImpressionId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = approvalLikelihood?.label === Likelihood.Excellent ? "334px" : "312px";
  let t4;
  if ($[6] !== t3) {
    t4 = {
      xs: "312px",
      md: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== approvalLikelihood || $[9] !== desktopStyle) {
    t5 = <Box position="relative" maxWidth="312px" display="grid" gridTemplateRows="repeat(3, auto)" gridTemplateColumns="repeat(5, 1fr)" columnGap={1}><CardsApprovalLine approvalLikelihood={approvalLikelihood} desktopStyle={desktopStyle} /></Box>;
    $[8] = approvalLikelihood;
    $[9] = desktopStyle;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Box marginY={1} maxWidth={t4}>{t5}</Box>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t6) {
    t7 = <FeatureViewed entityName="cc_approval_odds" entitySection="" impressionPosition={0} additionalAttributes={t2}>{t6}</FeatureViewed>;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default CardsApprovalOdds;